<template>
  <component
    :is="withoutPopup ? 'div' : 'bimPopup'"
    title=""
    width="350px"
    :value="value"
    @input="() => { withoutPopup ? false : closeModal() }"
    :class="{ 'phone-request__popup': !withoutPopup }"
  >
    <div class="d-flex flex-column justify-center">
      <bimText
        v-if="modalStep !== 'success'"
        class="mb-6 mb-md-10 text-center"
        type=accent
        bold
      >
        {{ $bimTranslate('phoneRequest.fillForm', activeLang) }}
      </bimText>

      <transition name="slide" mode="out-in">
        <StepPhoneNumber
          v-if="modalStep === 1"
          v-model="form"
          @next="changeStep"
          key=step1
        />

        <StepNameEmailINN
          v-if="modalStep === 2"
          v-model="form"
          @next="sendNameEmailINN"
          key=step2
        />

        <StepNameEmail
          v-if="modalStep === 3"
          v-model="form"
          @next="sendNameEmail"
          key=step3
        />

        <StepSuccess
          v-if="modalStep === 'success'"
          key=success
          @next="closeModal"
        />
      </transition>
    </div>
  </component>
</template>

<script>
/* eslint-disable */
import StepPhoneNumber from '@/components/core/bimPhoneRequest/StepPhoneNumber'
import StepNameEmailINN from '@/components/core/bimPhoneRequest/StepNameEmailINN'
import StepNameEmail from '@/components/core/bimPhoneRequest/StepNameEmail'
import StepSuccess from '@/components/core/bimPhoneRequest/StepSuccess'

import bimPopup from '@/components/ui/bimPopup/bimPopup'
import bimText from '@/components/text/bimText/bimText'

import { urlParams } from '@/utils/url'
import { tryWrapper } from '@/utils/helpers'
import { getCookie } from '@/utils/cookie'

/**
 * Работа с локальным хранилищем
 */
const addLsPprefix = str => 'feedback_form_' + str
const LS_FORM = {
  set (name, val) {
    localStorage.setItem(addLsPprefix(name), val)
  },
  get (name) {
    return localStorage.getItem(addLsPprefix(name))
  },
  getFormObj () {
    return Object.values(LS_ENUM).reduce((acc, key) => {
      const value = this.get(key)
      acc[key] = value || ''
      return acc
    }, {})
  },
  getFormData () {
    const form = new FormData()
    Object
      .entries(this.getFormObj())
      .forEach(([key, value]) => {
        form.append(key, value)
      })

    return form
  }
}

const LS_ENUM = {
  INN: 'inn',
  UTM: 'utm',
  NAME: 'name',
  PHONE: 'phone',
  EMAIL: 'email',
}

export default {
  components: {
    StepPhoneNumber,
    StepNameEmailINN,
    StepNameEmail,
    StepSuccess,

    bimText,
    bimPopup
  },
  provide () {
    return {
      activeLang: this.activeLang
    }
  },
  props: {
    value: Boolean,
    /**
     * Вывести форму без модального окна
     * */
    withoutPopup: Boolean,
    /**
     * Тип формы (какое-то легаси)
     */
    formType: {
      type: Number,
      default: null
    },
    /**
     * Контекст пользователя
     */
    userContext: {
      type: Object,
      default: () => ({})
    },
    /**
     * Дополнительная информация которая
     * будет отправлена на form_request
     */
    additionalInfo: String,
    /**
     * Префикс для запросов на апи
     */
    apiPrefix: {
      type: String,
      default: '/web-api-2'
    },
    activeLang: {
      type: String,
      default: 'ru'
    },
    /**
     * Функция для логирования открытия формы
     */
    logActionEvent: {
      type: Function,
      default: () => {}
    },
    /**
     * кастомная функция отправки данных о пользователе
     */
    sendFunction : {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      ya_login: '',
      UUID: '',
      utm: '',
      modalStep: 1,
      form: {
        phone: '',
        email: '',
        name: '',
        inn: ''
      },
      formCatcher: {
        location: '',
        date: '',
        id: '',
      }
    }
  },
  watch: {
    modalStep (step) {
      if (step === 'success') {
        /**
         * Все шаги пройдены и форма полностью заполнена
         */
        this.$emit('sended')
      }
    },
    value (val) {
      if (val && this.userContext.id) {
        this.setUserContext()
      }
    }
  },
  mounted () {
    if (this.userContext.id) {
      this.setUserContext()
    }

    this.initFormCatcher()

    this.UUID = localStorage.getItem('UUID')
    this.ya_login = getCookie('yandex_login') || ''

    const utmSource = urlParams.get('utm_source')
    if (utmSource) {
      this.utm = window.location.search
      LS_FORM.set(LS_ENUM.UTM, this.utm)
    }
  },
  computed: {
    userAccountType () {
      return (this.userContext.context || {}).role
    }
  },
  methods: {
    setUserContext () {
      const {
        email,
        firstName = '',
        lastName = '',
        fatherName = '',
        phone = ''
      } = this.userContext || {}
      this.form.phone = phone
      this.form.email = email
      this.form.name = `${firstName} ${lastName} ${fatherName}`
    },
    initFormCatcher () {
      const today = new Date()
      const path = window.location.pathname.split('/')[1]
      this.formCatcher.location = path.length ? path : 'main_page'
      this.formCatcher.id = Date.now()
      this.formCatcher.date = (
        today.getUTCHours() + 3 +
        ':' +
        today.getUTCMinutes() +
        ':' +
        today.getUTCSeconds() +
        ' ' +
        today.getDate() +
        ' ' +
        (today.getMonth() + 1) +
        ' ' +
        today.getFullYear()
      )
    },
    resetData () {
      this.modalStep = 1
      for (const key in this.form) {
        this.form[key] = ''
      }
    },
    /**
     * Получение объекта формы в FormData
     * @param {Object} additionalFields - дополнительные поля формы
     */
    getForm (additionalFields = {}) {
      return Object.assign(additionalFields, {
        phone: this.form.phone,
        first_name: this.form.name,
        servicesArray: this.additionalInfo ? JSON.stringify([{ name: this.additionalInfo }]) : null,
        email: this.form.email,
        type: this.userAccountType || null,
        agree: 'on',
        UUID: this.UUID,
        ya_login: this.ya_login,
        utm: this.utm
      })
    },
    cleanLocalStorageFromForm () {
      Object.values(LS_ENUM).forEach(key => {
        localStorage.removeItem(key)
      })
    },

    /**
     * логирование запросов,
     * отправляется в любом случае с
     * заполненными данными для сбора
     * статистики открытия формы
     */
    async sendFormCatcher (action, additionalFields) {
      const form = Object.assign(
        this.formCatcher,
        additionalFields ? this.getForm(additionalFields) : this.getForm()
      )

      try {
        const res = await this.logActionEvent(
          'send form ' + action,
          form
        )
        this.cleanLocalStorageFromForm()
        return res
      } catch (e) {}
    },

    /**
     * Отправка данных о пользователе
     */
    async sendUserData (form = this.getForm()) {
      const { phone } = form

      if (!phone || phone.length < 6) return

      if (this.sendFunction) {
        return this.sendFunction(this.form, form)
      }

      return fetch(
        this.apiPrefix +
        '/forms/form_request',
        {
          method: 'POST',
          body: JSON.stringify(form),
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
        .then(r => r.json())
    },

    /**
     * Сохранение данных формы в локальное
     * хранилище, удаление из компонента и
     * закрытие окна
     */
    closeModal () {
      for (const key in this.form) {
        LS_FORM.set(key, this.form[key])
      }
      this.resetData()
      this.$emit('input', false)
    },

    /**
     * Отправка формы с именем, емейлом и ИНН
     */
    sendNameEmailINN () {
      const form = this.getForm({
        inn: this.inn
      })

      this.sendUserData(form)
        .then(res => {
          if (res.data.success === true) {
            if (localStorage.getItem('dev_mode')) {
            } else {
              this.sendMetirkYandexUserParams()
              this.sendMetrikGoogle('PROFILE', 'SIGNUP')
              this.sendMetrikFacebookTrackCustom('PROFILE_SIGNUP')
              this.sendMetrikFacebookTrack()
            }
          }
          this.modalStep = 'success'
        })
        .catch(console.error)
        .finally(() => {
          this.sendFormCatcher('sendNameEmailINN', {
            inn: this.inn
          })
        })
    },
    /**
     * Отправка формы с именем и емейлом
     */
    async sendNameEmail () {
      this.sendMetirkYandexEmailFilling()
      this.sendMetrikGoogle('EMAIL', 'FILLING')
      this.sendMetrikFacebookTrackCustom('EMAIL_FILLING')
      this.sendMetrikFacebookTrack()

      this.modalStep = 'success'

      // попробуем зарегистрировать.. если получится, то пошлем еще метрику
      setTimeout(() => {
        this.sendUserData(this.getForm())
          .then(res => res.data)
          .then(res => {
            if (res && res.success && !localStorage.getItem('dev_mode')) {
              this.sendMetirkYandexUserParams()
              this.sendMetrikGoogle('PROFILE', 'SIGNUP')
              this.sendMetrikFacebookTrackCustom('PROFILE_SIGNUP')
            }
          })
          .catch(console.error)
          .finally(() => {
            this.sendFormCatcher('sendNameEmail')
          })
      })
    },
    changeStep () {
      if (this.formType === 1) {
        this.modalStep = 2
        return
      }

      if (!this.userContext.id) {
        this.modalStep = 3
        return
      }

      this.sendNameEmail()
      this.modalStep = 'success'
    },
    /**
     * Метрики
     */
    sendMetrikFacebookTrack () {
      tryWrapper(
        () => fbq('track', 'Lead')
      )
    },
    sendMetrikFacebookTrackCustom (value) {
      tryWrapper(
        () => fbq('trackCustom', value)
      )
    },
    sendMetrikGoogle (eventCategory, eventAction) {
      tryWrapper(
        () => {
          dataLayer.push({
            event: 'EVENT2GA',
            eventCategory,
            eventAction,
            eventLabel: '',
            eventValue: ''
          })
        }
      )
    },
    sendMetirkYandexEmailFilling () {
      tryWrapper(
        () => ym(40131035, 'reachGoal', 'EMAIL_FILLING')
      )
    },
    sendMetirkYandexUserParams () {
      tryWrapper(
        () => {
          const {
            phone = '',
            email = '',
            company = '',
            id
          } = this.userContext

          const isManufacturer = this.userAccountType === 'manufacturer'

          ym(40131035, 'userParams', {
            UserID: id,
            manufacturer: isManufacturer,
            designer: !isManufacturer,
            UserPhone: phone,
            UserMail: email,
            UserCompany: company,
          })
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-enter {
  transform: translateX(25rem);
  opacity: 0;
}

.slide-enter-to,
.slide-leave {
  transform: translateX(0);
}

.slide-leave-to {
  transform: translateX(-25rem);
  opacity: 0;
}

.phone-request__popup {
  ::v-deep {
    .modal-content {
      width: 100%;
    }
    .modal-body {
      overflow: hidden;
    }
  }
}
</style>
